import { ChartPie, FileCheck, FileLock, HandCoins, UserX } from "lucide-react";

import {
  type ILenderResponseBenefit,
  LenderResponseBenefitTypeEnum,
} from "../../types/lenderResponseBenefit";
import { EuFlag } from "../icons/EuFlag";

// Exhaustive so a new benefit type cannot be added without an icon: BidBenefits
// skips an icon-less benefit, which is how NO_RECOURSE silently went missing.
const ICON_BY_BENEFIT_TYPE: Record<
  LenderResponseBenefitTypeEnum,
  ILenderResponseBenefit["icon"]
> = {
  [LenderResponseBenefitTypeEnum.NO_ADDITIONS_REQUIRED]: FileCheck,
  [LenderResponseBenefitTypeEnum.REDUCED_GUARANTOR_COMMITMENT]: ChartPie,
  [LenderResponseBenefitTypeEnum.NO_GUARANTOR_REQUIRED]: UserX,
  [LenderResponseBenefitTypeEnum.FREE_EARLY_PAYMENT]: HandCoins,
  [LenderResponseBenefitTypeEnum.NO_LEASING_DOWN_PAYMENT]: HandCoins,
  [LenderResponseBenefitTypeEnum.NO_WITHDRAWAL_FEE]: HandCoins,
  [LenderResponseBenefitTypeEnum.NO_LIMIT_FEE]: HandCoins,
  [LenderResponseBenefitTypeEnum.NO_SETUP_FEE]: HandCoins,
  [LenderResponseBenefitTypeEnum.EU_LOAN]: EuFlag,
  [LenderResponseBenefitTypeEnum.NO_RECOURSE]: FileLock,
  [LenderResponseBenefitTypeEnum.NO_AMORTIZATION]: HandCoins,
};

export const getBenefits = (
  benefits?: ILenderResponseBenefit[],
): ILenderResponseBenefit[] => {
  if (!benefits) return [];

  return benefits.map((benefit) => ({
    ...benefit,
    icon: ICON_BY_BENEFIT_TYPE[benefit.type],
  }));
};
